module.exports = {"530321001":"通泉街道","530321002":"鸡头村街道","530321003":"王家庄街道","530321004":"张安屯街道","530321005":"旧县街道","530321103":"马过河镇","530321105":"纳章镇","530321201":"马鸣乡","530321202":"大庄乡","530321203":"月望乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530321.json
// module id = 2690
// module chunks = 0